import {createSelector} from 'reselect';

import {ApplicationStoreType} from 'reducers';

import {MODULE_KEY} from '../../constants';
import {PostPurchaseInsurancePaymentType, PaymentsType, PaymentMethodStateType} from './types';

/**
 * Return payment local state
 * @param {ApplicationStoreType} store - application store
 * @return {PostPurchaseInsurancePaymentType} - payment state
 */
export const getStatePayment = (store: ApplicationStoreType): PostPurchaseInsurancePaymentType =>
    store[MODULE_KEY].payment;

/**
 * Return payment methods
 * @param {ApplicationStoreType} store - application store
 * @return {Payment[]} - payment methods
 */
export const getPayments = createSelector(
    getStatePayment,
    (state): PaymentMethodStateType => state.methods,
);

/**
 * Return active payment method
 * @param {ApplicationStoreType} store - application store
 * @return {Payments} - payment method
 */
export const getActivePaymentMethod = createSelector(
    getStatePayment,
    (state): PaymentsType => {
        return state.methods[state.activePayment];
    },
);

/**
 * Return saved card
 * @param {ApplicationStoreType} store - application store
 * @return {PostPurchaseInsurancePaymentType} - payment state
 */
export const getSavedCards = createSelector(getPayments, methods => methods.ms_paymentsos.cards);
